import React, { useState } from "react"
import { useAuth } from "../AuthContext"
// 1. Import React Router hooks
import { useNavigate, Navigate } from "react-router-dom"

// 2. Remove 'setPage' prop, as navigation is now handled by the router
const LoginPage = () => {
  // 3. Hook into the global authentication context and router
  const auth = useAuth()
  const navigate = useNavigate() // Hook for programmatic navigation

  // 4. Local state for form inputs and error handling
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  // 5. FIX FOR "STUCK" PAGE:
  // If the user is already authenticated (e.g., page refresh, or on login success),
  // redirect them to the dashboard homepage ("/")
  if (auth.isAuthenticated) {
    return <Navigate to="/" replace />
  }

  // 6. Handle the form submission (this logic is mostly the same)
  const handleLogin = async e => {
    e.preventDefault()
    setError(null)

    if (!email || !password) {
      setError("Please enter both email and password.")
      return
    }

    setIsSubmitting(true)
    try {
      // Calls the login function from AuthContext
      await auth.login(email, password)

      // On success, the 'isAuthenticated' check (Fix 5) will trigger the redirect
      // to the dashboard automatically on the next render.
    } catch (err) {
      // API call failed (e.g., 401 Unauthorized, 500 Server Error)
      const errorMessage = err.message.includes("Invalid login")
        ? "Invalid email or password. Please try again."
        : err.message || "Login failed due to a network error."

      setError(errorMessage)
    } finally {
      setIsSubmitting(false)
    }
  }

  const isDisabled = isSubmitting || auth.isLoading

  return (
    <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-2xl">
      <h2 className="text-3xl font-bold mb-6 text-gray-800 text-center">
        CCACC Rental Client Login
      </h2>

      <form onSubmit={handleLogin}>
        {/* Display Error Message */}
        {error && (
          <div
            className="p-3 mb-4 text-sm text-red-700 bg-red-100 rounded-lg"
            role="alert"
          >
            {error}
          </div>
        )}

        {/* Email Input */}
        <input
          className="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="Email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          disabled={isDisabled}
        />

        {/* Password Input */}
        <input
          className="w-full p-3 mb-6 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          disabled={isDisabled}
        />

        {/* Login Button */}
        <button
          type="submit"
          className={`w-full py-3 text-white font-semibold rounded-lg transition duration-150 shadow-md 
            ${
              isDisabled
                ? "bg-indigo-400 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700"
            }`}
          disabled={isDisabled}
        >
          {isSubmitting ? "Logging In..." : "Log In"}
        </button>
      </form>

      <div className="mt-6 text-center text-sm space-y-2">
        {/* 7. FIX FOR BROKEN LINKS: Use navigate() */}
        <button
          onClick={() => navigate("/forgot-password")}
          className="text-indigo-600 hover:text-indigo-800 transition duration-150"
        >
          Forgot Password?
        </button>
        <p className="text-gray-500">
          New user? Click the link in your email to{" "}
          <span className="text-indigo-600 font-medium">Register</span>
        </p>
      </div>
    </div>
  )
}

export default LoginPage
